<!-- Confirmation Modal -->
@if (isVisible) {
  <div #modal class="modal show" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="false" (click)="onBackdropClick($event)" style="display: block; z-index: 2000;">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmationModalLabel">
            @if (modalData?.iconClass) {
              <i [class]="modalData!.iconClass + ' me-2'"></i>
            }
            {{ modalData?.title || 'Confirm Action' }}
          </h5>
          <button type="button" class="btn-close" (click)="onCancel()" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          @if (!modalData?.hideMessage) {
            <p>{{ modalData?.message || 'Are you sure you want to proceed?' }}</p>
          }
          @if (modalData?.itemName) {
            <div class="alert alert-warning">
              <strong>{{ modalData!.itemName }}</strong>
            </div>
          }
          @if (modalData?.details) {
            <div class="alert alert-info">
              <i class="bi bi-info-circle me-2"></i>
              {{ modalData!.details }}
            </div>
          }
          @if (!modalData?.details && !modalData?.hideDefaultNote) {
            <p class="text-muted">This action cannot be undone.</p>
          }
        </div>
        <div class="modal-footer">
          @if (!modalData?.hideCancelButton) {
            <button type="button" class="btn btn-secondary" (click)="onCancel()">
              <i class="bi bi-x-circle me-1"></i>
              Cancel
            </button>
          }
          <button
            type="button"
            [class]="'btn ' + (modalData?.confirmButtonClass || 'btn-danger')"
            [disabled]="isLoading"
            (click)="onConfirm()">
            @if (isLoading) {
              <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            } @else {
              <i class="bi bi-check-circle me-1"></i>
            }
            {{ modalData?.confirmButtonText || 'Confirm' }}
          </button>
        </div>
        @if (modalData?.errorMessage) {
          <div class="alert alert-danger mb-3" role="alert">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ modalData!.errorMessage }}
          </div>
        }
      </div>
    </div>
  </div>
  <!-- Backdrop -->
  <div class="modal-backdrop show" style="z-index: 1990;"></div>
}
